// TODO get this from cordra-client?
import { Utf8 } from './Utf8.js';
import { Utf16 } from './Utf16.js';
import { Base64 } from './Base64.js';
import { Hex } from './Hex.js';

export const Encoder = { Utf8, Utf16, Hex, Base64 };
